import strings from './string/index';
export const R = { strings };
